const features = [
  {
    icon: 'ri-file-list-3-line',
    title: '原版无删减',
    desc: '保留完整分镜、对白与剧情，呈现最原汁原味的漫画内容。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清完整版',
    desc: '高清画质清晰呈现每一格细节，完整版剧情一话不少。',
  },
  {
    icon: 'ri-speed-line',
    title: '每日更新',
    desc: '连载漫画实时同步，最新章节第一时间送达你的书架。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '稳定追更',
    desc: '阅读进度云端保存，多设备无缝续读，追更不折腾。',
  },
];

const testimonials = [
  {
    name: '漫画老饕',
    tag: '追更三年',
    text: '在这里追《剑道独尊》看完了完整结局，导演剪辑版补全的巅峰对决真的过瘾，分镜细节都保留得很完整。',
  },
  {
    name: '夜猫子',
    tag: '科幻迷',
    text: '机甲纪元原版画面细节全都在，删减的战斗场面一个不少，画质也清晰，深夜刷起来完全停不下来。',
  },
  {
    name: '青柠',
    tag: '治愈系',
    text: '萌宠咖啡屋画风太治愈了，每一话都暖暖的。更新很稳定，评论区的同好也都很友善，体验很好。',
  },
];

export default function About() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-500">
            <i className="ri-information-line"></i> 关于麻瓜漫画
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">
            只做一件事：把原版漫画原原本本地带给你
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            麻瓜漫画网是一个专注原版漫画在线阅读的平台。我们相信，真正好看的漫画值得被完整呈现。
            因此我们坚持收录高清完整版、未删减原版与导演剪辑版资源，保留每一格分镜、每一句对白，
            不删减、不打码，让你看到作者想让你看到的样子。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            从热血的长篇连载，到治愈的日常小品，覆盖十多种题材。无论你是老漫迷还是刚入坑的新人，
            都能在这里找到属于自己的故事，畅快追更不折腾。
          </p>

          <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex gap-3 rounded-xl bg-background-100 p-4 ring-1 ring-background-200/50"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-500">
                  <i className={`${f.icon} text-lg`}></i>
                </span>
                <div>
                  <h4 className="text-sm font-bold text-foreground-950">{f.title}</h4>
                  <p className="mt-1 text-xs leading-5 text-foreground-500">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl ring-1 ring-background-300/50">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20comic%20studio%20desk%20with%20open%20manga%20books%20and%20drawing%20sketches%20under%20warm%20lamp%20light%2C%20a%20reader%20relaxing%20on%20a%20bean%20bag%20with%20a%20tablet%2C%20warm%20orange%20and%20amber%20tones%2C%20anime%20style%20illustration%2C%20inviting%20atmosphere%2C%20high%20detail&width=900&height=700&seq=about-workshop&orientation=portrait"
              alt="麻瓜漫画网阅读场景"
              loading="lazy"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -left-3 md:left-6 rounded-xl bg-primary-500 p-5 text-background-50 shadow-lg">
            <p className="font-heading text-3xl">1,200+</p>
            <p className="mt-1 text-xs text-background-950/70">部原版漫画持续收录中</p>
          </div>
          <div className="absolute top-5 right-5 rounded-xl bg-background-200/90 px-4 py-3 backdrop-blur-sm ring-1 ring-background-300/50">
            <p className="flex items-center gap-1 text-sm font-bold text-accent-500">
              <i className="ri-heart-3-fill"></i> 百万漫迷的选择
            </p>
          </div>
        </div>
      </div>

      {/* testimonials */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex flex-col rounded-xl bg-background-100 p-6 ring-1 ring-background-200/50"
          >
            <div className="flex gap-0.5 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-6 text-foreground-700">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
                <i className="ri-user-smile-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.tag}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}